import { FC, useState } from 'react';
import { useStripe, useElements, CardElement } from '@stripe/react-stripe-js';
import {
  Grid,
  useTheme,
  FormHelperText,
} from '@mui/material';
import { translateLanguage } from 'components';
import { LoadingButton } from '@mui/lab';
import { OnlineBookingContent } from 'models';
import {
  bookingButtonContainedStyle,
} from 'styles/componentStyle';

const SaveCardDetails: FC<any> = ({ handleCardResponse }) => {
  const stripe = useStripe();
  const elements = useElements();
  const theme = useTheme();
  const [message, setMessage] = useState<any>(null);
  const [isProcessing, setIsProcessing] = useState<any>(false);

  const handleSubmit = async (e: any) => {
    e.preventDefault();

    if (!stripe || !elements) {
      return;
    }
    setIsProcessing(true);
    try {
      const cardElement = elements.getElement(CardElement) as any;
      if (!cardElement) {
        return;
      }
      const { paymentMethod, error } = await stripe.createPaymentMethod({
        type: 'card',
        card: cardElement,
      });

      if (error) {
        if (error.type !== null) {
          setMessage(error.message);
        } else {
          setMessage(
            `${translateLanguage(
              `OnlineBooking.${OnlineBookingContent.PAYMENTFAILMSG}`,
            )}`,
          );
        }

        setIsProcessing(false);
      } else {
        handleCardResponse(paymentMethod);
      }
    } catch (error) {
      // An unexpected error occurred
      // handlePaymentResponse(error, false);
      setMessage(
        `${translateLanguage(
          `OnlineBooking.${OnlineBookingContent.PAYMENTFAILMSG}`,
        )}`,
      );
      setIsProcessing(false);
    }
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <FormHelperText error={message}>{message && message}</FormHelperText>
      </Grid>
      <Grid item xs={12}>
        <CardElement />
      </Grid>
      <Grid item xs={12} mt={2} display={'flex'} justifyContent={'center'}>
        <Grid item xs={12}>
          <LoadingButton
            name="payNowBtn"
            variant="contained"
            onClick={handleSubmit}
            sx={{
              m: theme.spacing(1),
              width: 1,
              borderRadius: '4px',
              marginLeft: 0,
              ...bookingButtonContainedStyle,
            }}
            type="button"
            loading={isProcessing}
            id="payNowBtn"
          >
            Save
          </LoadingButton>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default SaveCardDetails;
